@if (content) {
<shell></shell>
<div [ngClass]="content?.variant === 'light' ? 'bg-col-51' : 'bg-col-1'"
     class="z-1 pos-relative">
    <div class="wrap-x">
        <div sizeClass="SM:p-l-4 p-r-4, L:p-a-10"
             class="w-12 flex flex-column p-t-8 p-b-0-x p-b-0-l">
            @if(!content.showBreadcrumb) {
            <breadcrumbs [variant]="content?.variant"
                         class="m-b-8 m-b-4-m m-b-4-s m-t-5-x m-t-5-l block no-scrollbar overflow-auto flex flex-justify-left">
            </breadcrumbs>
            }

            <div class="flex flex-column">
                <div class="m-b-8 m-b-4-m m-b-4-s"
                     [ngClass]="content?.variant === 'light' ? 'col-1' : 'col-w'">

                    <p class="h2 w-12 m-b-8 m-b-4-m m-b-4-s"
                       *iCms="'title' of content; content: 'html'"></p>

                    <view-more class=" w-8 w-12-s w-12-m"
                               [text]="content?.description"></view-more>
                </div>
            </div>
        </div>
        @if(content?.links?.length > 0) {
        <div sizeClass="SM:p-l-4 p-r-4, L:p-a-10"
             class="w-12 p-b-8 p-b-10-l p-b-10-x left _drag-container no-wrap"
             dragScroll>
            @for (item of content.links; track $index) {
            <div class="inline-flex flex-middle va-t p-a-2 p-l-3 p-r-3 _drag-item"
                 [class.m-r-3]="!$last">
                <href [link]="item.url">
                    <div class="inline-flex flex-middle">
                        @if (item.image) {
                        <div class="ratio-1-1 overflow-hidden b-radius-max m-r-2"
                             [ngStyle]="{'width': '44px', 'height': '44px'}">
                            <shell />
                            <img draggable="false"
                                 class="_drag-item"
                                 [ratio]="1"
                                 [dfImage]="item.image"
                                 [fill]="true">
                        </div>
                        }
                        <p class="s2 center overflow-hidden"
                           [ngClass]="content.variant === 'light' ? 'col-1' : 'col-w'"
                           *iCms="'text' of item">
                        </p>
                    </div>
                </href>
            </div>
            }
        </div>
        }
    </div>
</div>
}
